/**
 * Replacement of polished lib
 * https://bit.cloud/styled-components/polished/
 */

export const numberToHex = (value: number): string => {
  const hex = value.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
};
